// client/src/coms/components/comslayout_parts/useComsViewport.js
import { useEffect, useRef, useState } from 'react';
import { isMobileViewport } from './layoutUtils';

export default function useComsViewport() {
  const [mobile, setMobile] = useState(() => isMobileViewport());
  const [leftOpen, setLeftOpen] = useState(false);
  const [rightOpen, setRightOpen] = useState(false);
  const closePanelsRef = useRef(() => {});

  useEffect(() => {
    function onResize() {
      const m = isMobileViewport();
      setMobile(m);
      if (!m) {
        setLeftOpen(false);
        setRightOpen(false);
      }
    }
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    mobile,
    setMobile,
    leftOpen,
    setLeftOpen,
    rightOpen,
    setRightOpen,
    closePanelsRef,
  };
}